import {WalletConnectConnector} from "@wagmi/core/connectors/walletConnect";

export function buildWalletConnectConnector(chains): WalletConnectConnector {
  return new WalletConnectConnector({
    chains,
    options: {
      projectId: 'c8826c9258d3ce2a85d982a5fe45d2cb',
      showQrModal: true,
    },
  })
}
